import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

export default async function updateCart(platformId: string, cartId: string, data: any) {
  const ref = doc(firestore, 'platforms', platformId, 'carts', cartId);

  await updateDoc(ref, data);
}
